import { Component, computed, inject, Inject, Signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Shoutout } from 'src/app/models/shoutout.model';
import { ShoutoutStoreService } from 'src/app/services/stores/shoutout.store.service';

@Component({
  selector: 'app-announce',
  templateUrl: './announce.component.html',
  styleUrls: ['./announce.component.scss'],
  standalone: false,
  providers: [ShoutoutStoreService],
})
export class AnnounceComponent {
  private _shoutoutStoreService = inject(ShoutoutStoreService);
  protected shoutout: Signal<Shoutout | undefined> = computed(() =>
    this.shoutouts().length > 0 ? this.shoutouts()[0] : undefined,
  );
  protected nothingToAnnounce: Signal<boolean> = computed(() => {
    if (this.shoutouts().length > 0) {
      return false;
    } else {
      return true;
    }
  });

  constructor(
    public dialogRef: MatDialogRef<AnnounceComponent>,
    @Inject(MAT_DIALOG_DATA) public shoutouts: Signal<Shoutout[]>,
  ) {}

  markAsAnnounced() {
    const shoutout = this.shoutout();
    if (!shoutout) return;
    this._shoutoutStoreService.update({
      ...shoutout,
      moderated: true,
      approved: true,
      announced: true,
    });
  }

  reject() {
    const shoutout = this.shoutout();
    if (!shoutout) return;
    this._shoutoutStoreService.update({
      ...shoutout,
      moderated: true,
      approved: false,
      announced: false,
    });
  }
}
